import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";

import type { UUID } from "../../../utils/uuid";
import type { InsightKeyFieldWithData } from "../server/supabase-insight-key-field-service";
import type { FC } from "react";

interface Props {
  fields: InsightKeyFieldWithData[];
  onEdit: (field: InsightKeyFieldWithData) => void;
  onDelete: (id: UUID) => void;
}

export const InsightKeyFieldList: FC<Props> = ({ fields, onEdit, onDelete }) => {
  const [deleteTarget, setDeleteTarget] = useState<InsightKeyFieldWithData | null>(null);

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Field</TableCell>
            <TableCell>Display name</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {fields.map((field) => (
            <TableRow key={field.id}>
              <TableCell>{field.field_key}</TableCell>
              <TableCell>{field.display_name}</TableCell>
              <TableCell align="right">
                <IconButton
                  size="small"
                  data-analytics-id="insight-key-field-edit"
                  onClick={() => onEdit(field)}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  data-analytics-id="insight-key-field-delete"
                  onClick={() => setDeleteTarget(field)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Dialog open={deleteTarget !== null} onClose={() => setDeleteTarget(null)}>
        <DialogTitle>Remove this field?</DialogTitle>
        <DialogContent>
          <DialogContentText>Future insights won’t use it.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            data-analytics-id="insight-key-field-delete-cancel"
            onClick={() => setDeleteTarget(null)}
          >
            Cancel
          </Button>
          <Button
            color="error"
            data-analytics-id="insight-key-field-delete-confirm"
            onClick={() => {
              if (deleteTarget) onDelete(deleteTarget.id);
              setDeleteTarget(null);
            }}
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
